var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div dias-cloak=\"vm.loading\" class=\"list-group\"><div ng-repeat=\"elId in vm.parameter[vm.key].wert track by $index\" class=\"list-group-item\"><span><strong>{{ $index + 1 }}.&nbsp;<a ui-sref=\"root.foerderregeln.detail({id: elId})\">{{ vm.getRegelbez(elId) }}</a></strong></span></div></div>");;return buf.join("");
}